import React, { useState } from 'react'
import { IconButton } from '@mui/material'
import { DeleteSharp } from '@mui/icons-material'
import { SKUOnDeleteConfirmationPopup } from './SKUOnDeleteConfirmationPopup.jsx'

export const SKUDeleteButton = ({ handleUpdateClick, rows, selection, throwError }) => {

    const [showPopup, setShowPopup] = useState(false)

    const togglePopup = () => {
        setShowPopup(!showPopup)
    }

    let selectedRows = rows.filter((row, idx) => selection.includes(idx))

    return (
        <div>
            <IconButton
                aria-label="Delete"
                onClick={(event) => {
                    if (selection.length === 0) {
                        throwError(event, `Please, select at least one row to delete.`)
                    } else {
                        togglePopup()
                    }
                }}
                size="large"
            >
                <DeleteSharp />
            </IconButton>

            <SKUOnDeleteConfirmationPopup
                showPopup={showPopup}
                setShowPopup={setShowPopup}
                togglePopup={togglePopup}
                handleUpdateClick={handleUpdateClick}
                selectedRows={selectedRows}
            />
        </div>
    )
}